import styled from 'styled-components'

const Content = styled.div`
  flex-grow: 1;
`

export default Content
